<template>
  <transition name="opt-modal">
    <div class="opt-modal-mask">
      <div class="opt-modal-wrapper">
        <div class="card opt-modal-container" v-if="busy!=false">
          <div class="card-header">
            <slot name="header">
              <button type="button" class="close" @click="$emit('close')">×</button>
              <h4 class="card-title">
                <slot name="header-title">default header</slot>
              </h4>
            </slot>
          </div>
          <div class="card-body opt-modal-busy">{{ busyMsg ? busyMsg : '... Подождите, идет обработка запроса ...' }}</div>
        </div>
        <div class="card opt-modal-container" v-if="busy==false">
          <div class="card-header">
            <slot name="header">
              <button type="button" class="close" @click="$emit('close')">×</button>
              <h4 class="card-title">
                <slot name="header-title">default header</slot>
              </h4>
            </slot>
          </div>

          <div class="card-body">
            <div class="card-block">
              <slot name="body">default body</slot>
            </div>
          </div>

          <div class="card-footer">
            <slot name="footer">
              <div class="float-xs-right">
                <button
                  class="btn btn-default btn-hover"
                  style="margin-right: 10px;"
                  @click="$emit('cancel')"
                  v-if="showCancelButton"
                >
                  <slot name="cancel-title">Отмена</slot>
                </button>
                <button class="btn btn-success bg-green bg-darken-3 btn-hover"
                  @click="$emit('ok')"
                  v-if="showOkButton"
                >
                  <slot name="ok-title">OK</slot>
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  props: {
    busy: Boolean,
    busyMsg: String,
    showOkButton: {type: Boolean, default: true},
    showCancelButton: {type: Boolean, default: true},
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style>
.opt-modal-busy {
  text-align: center;
  /*color: rgba(255,255,255);
  background: rgba(0,0,0,0.75);*/
  padding: 1em;
}
.opt-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.1s ease;
}

.opt-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.opt-modal-container {
  width: 100%;
  max-width: 500px;
  margin: 0px auto;
  /*padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);*/
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.opt-modal-body {
  margin: 20px 0;
}

.opt-modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.opt-modal-enter,
.opt-modal-leave-active {
  opacity: 0;
}

.opt-modal-enter-active,
.opt-modal-leave-active {
  transition: opacity 0.1s ease;
}
</style>